/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateDefaultRfidTagRequest
 */
export interface UpdateDefaultRfidTagRequest {
    /**
     *
     * @type {string}
     * @memberof UpdateDefaultRfidTagRequest
     */
    value?: string;
}

/**
 * Check if a given object implements the UpdateDefaultRfidTagRequest interface.
 */
export function instanceOfUpdateDefaultRfidTagRequest(
    value: object,
): value is UpdateDefaultRfidTagRequest {
    return true;
}

export function UpdateDefaultRfidTagRequestFromJSON(
    json: any,
): UpdateDefaultRfidTagRequest {
    return UpdateDefaultRfidTagRequestFromJSONTyped(json, false);
}

export function UpdateDefaultRfidTagRequestFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateDefaultRfidTagRequest {
    if (json == null) {
        return json;
    }
    return {
        value: json["value"] == null ? undefined : json["value"],
    };
}

export function UpdateDefaultRfidTagRequestToJSON(
    value?: UpdateDefaultRfidTagRequest | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        value: value["value"],
    };
}
